import request from '@/utils/request'

let HyApi = {


  userlist(data) {
        return request._post('/shop/plus.hy.Index/index', data);
    },

  /*删除货运公司*/
      deleteuser(data) {
        return request._post('/shop/user.user/delete', data);
  },


/*添加货运公司*/
add(data) {
    return request._post('/shop/plus.hy.Index/add', data);
},
/*修改货运公司*/
edit(data) {
    return request._post('/shop/plus.hy.Index/edit', data);
},
/*删除货运公司*/
del(data) {
    return request._post('/shop/plus.hy.Index/del', data);
},
/*货运公司详情*/
detail(data) {
  return request._post('/shop/plus.hy.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.hy.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.hy.Setting/getSetting', data, errorback);
    },
}
export default HyApi;



// WEBPACK FOOTER //
// ./src/api/hy.js